export const Configs = {
  comments: {
    limit: 10,
  },
  replies: {
    limit: 10,
  },
}
